import { ICON_COLOR } from '@zep-us/zus/tokens';
import { AnswerIconO, AnswerIconX } from '@/shared/components/AnswerIcon';
import { cn } from '@/utils/tailwind.util';
import { type BuildQuizListItem } from '../../type';
export const OXEdit = ({
  answer,
  onChange,
  isVisible
}: {
  answer: BuildQuizListItem['oxData']['answer'];
  onChange: (value: BuildQuizListItem['oxData']['answer']) => void;
  isVisible: boolean;
}) => {
  return <div className={cn('w-full justify-between gap-sm hidden', isVisible && 'flex')} onFocus={e => {
    console.warn('onFocus');
    e.stopPropagation();
  }} tabIndex={0} data-sentry-component="OXEdit" data-sentry-source-file="OXEdit.tsx">
      <Container className={cn(answer === 'o' && 'bg-status-positive')} onClick={() => onChange('o')} data-sentry-element="Container" data-sentry-source-file="OXEdit.tsx">
        <AnswerIconO className="size-[88px]" color={answer === 'o' ? ICON_COLOR.inverse : ICON_COLOR.disabled} data-sentry-element="AnswerIconO" data-sentry-source-file="OXEdit.tsx" />
      </Container>
      <Container className={cn(answer === 'x' && 'bg-status-destructive')} onClick={() => onChange('x')} data-sentry-element="Container" data-sentry-source-file="OXEdit.tsx">
        <AnswerIconX className="size-[88px]" color={answer === 'x' ? ICON_COLOR.inverse : ICON_COLOR.disabled} data-sentry-element="AnswerIconX" data-sentry-source-file="OXEdit.tsx" />
      </Container>
    </div>;
};
const Container = ({
  children,
  className,
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}) => {
  return <div className={cn('flex items-center justify-center p-md h-[160px] rounded-md border border-alternative flex-1 cursor-pointer', className)} onClick={onClick} data-sentry-component="Container" data-sentry-source-file="OXEdit.tsx">
      {children}
    </div>;
};